module.exports = __webpack_public_path__ + "assets/SBSansUI-Regular.a48061b4efbbfd957729fd208df1677494dba8c06f86d8f32b90df11ef0158e1.ttf";